import axios from "axios";
import { BACKEND_URL, BACKEND_URL_CLAIM } from "../utils/constant";

const getLoanFiles = async (token, limit, offset) => {
    const config = {
        headers: { authorization: `Bearer ${token}` },
    };
    const response = await axios.get(
        `${BACKEND_URL}api/loan_files?limit=${limit}&offset=${offset}`,
        config
    );
    return response;
};

const getLoanFile = async (token, insurance_id) => {
    const config = {
        headers: { authorization: `Bearer ${token}` },
    };
    const response = await axios.get(
        `${BACKEND_URL}api/loan_files/${insurance_id}`,
        config
    );
    return response;
};

const deleteLoanFile = async (token, id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.delete(
        `${BACKEND_URL_CLAIM}cblcust/ClaimNewStruts/${id}`,
        config
    );
    return response;
};

const updateLoanFile = async (token, id, formData) => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.put(
        `${BACKEND_URL_CLAIM}cblcust/ClaimNewStruts/${id}`,
        formData,
        config
    );
    return response;
};

export default {
    getLoanFiles,
    getLoanFile,
    deleteLoanFile,
    updateLoanFile,
};
